import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PatientService } from 'src/app/patient/patient.service';
import { CaseNote } from './case-note';

@Component({
  selector: 'app-add-note-popup',
  templateUrl: './add-note-popup.component.html',
  styleUrls: ['./add-note-popup.component.css']
})
export class AddNotePopupComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal,
    private patientService: PatientService,

  ) { }
  @Input() public data;
  waitingRoomId: any;
  s_id: any;
  patient_id: any;
  caseList: any;
  editCaseList: any;
  notes: any;
  caseId: any;
  appoinmentId: any;
  valueAvailable = false;
  newCaseNote = new CaseNote();
  noteList: any = [];
  caseIds: any[] = [];
  list_availabel = false;

  ngOnInit() {

    if (this.data.waitingRoomId && this.data.waitingRoomId > 0) {
      this.waitingRoomId = this.data.waitingRoomId;
    } else {
      this.waitingRoomId = 0;
      this.appoinmentId = this.data.appointment_id;
    }
    this.s_id = this.data.s_id;
    this.patient_id = this.data.patient_id;
    this.getAllCasesForDropdown();

  }
  getAllCasesForDropdown() {
    this.patientService.getCaseList(this.waitingRoomId, this.patient_id, this.s_id).subscribe((info: any) => {
      this.caseList = info;
      this.editCaseList = info;
      this.caseList.forEach(ele => {
        this.caseIds.push(ele.case_id);
      });
      this.caseNoteList();
    });
  }

  saveNotes() {

    this.newCaseNote.caseId = this.caseId;
    this.newCaseNote.noteText = this.notes;
    this.patientService.saveCaseNotes(this.newCaseNote).subscribe((info: any) => {
      this.notes = '';
      this.caseNoteList();
    });
  }
  onClose() {
    this.activeModal.close();
  }

  caseNoteList() {

    const caseIds: any[] = [];
    this.patientService.caseNoteList(this.caseIds, this.appoinmentId, this.waitingRoomId, this.s_id).subscribe((info: any) => {
      if (info) {
        this.noteList = info;
        if (this.noteList.length > 0) {
          this.list_availabel = true;
        }
        // Reset Drop down
        this.noteList.forEach(ele => {
          caseIds.push(ele.caseId);
        });
        this.caseList = this.caseList.filter((o) => !caseIds.includes(+o.case_id));
      }

    });

  }
  editNote(data) {
    this.caseList = this.editCaseList;
    const index = this.noteList.indexOf(data);
    this.caseId = this.noteList[index].caseId;
    this.notes = this.noteList[index].noteText;
    this.newCaseNote.caseNoteId = this.noteList[index].caseNoteId;
  }
}
